export default {
  singular: 'Payment',
  plural: 'Payments'
};
